(function () {
  'use strict';
  var D = window.MPR_ROOMS, sec = document.getElementById('mpr');
  if (!D || !sec) return;
  var xs = document.createElement('style');
  xs.textContent = '.mpr .mpr-in{max-width:1400px}@media(min-width:1100px){.mpr .mpr-grid{columns:3}}.mpr .mpr-room{transform:translateZ(0);-webkit-transform:translateZ(0);contain:paint;-webkit-backface-visibility:hidden;backface-visibility:hidden;touch-action:pan-y}.mpr .mpr-st{-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:opacity .4s ease}.mpr .mpr-room.is-zoom .mpr-st,.mpr .mpr-room.is-zoom .mpr-art{will-change:transform}.mpr .mpr-note{min-height:1.5em}';
  document.head.appendChild(xs);
  var CDN = 'https://cdn.shopify.com/s/files/1/0185/3338/4256/files/mpr-';
  var MOB = window.innerWidth < 768;
  var TOL = 0.01, PER = (MOB ? 4 : 6), MAXZ = 2, STYLES = ['bold', 'thin', 'squashed'];
  var BW = MOB ? 1100 : 1400, AWD = MOB ? 700 : 1400, CAW = MOB ? 1100 : 2048;
  var grid = sec.querySelector('.mpr-grid'), tabs = sec.querySelector('.mpr-tabs'),
      more = sec.querySelector('.mpr-more'), note = sec.querySelector('.mpr-note');
  var arts = {}, fpv = null, last = '', pend = '', picked = '', lastRow = '', shown = 0, list = [], ctx = null, io = null, ratios = {}, colourMode = false;
  var queue = [], active = 0, MAXC = 3, tok = 0;
  var handle = (location.pathname.split('/products/')[1] || 'x').split('/')[0];
  var isCustom = /^(personalised|custom)/.test(handle) || /(street-name|mixtape|mix-tape|book-cover)/.test(handle);
  var AL = { aqua: 'teal', light_blue: 'sky_blue', gray: 'grey' };
  var GB = { chance: 'version_1', community_chest: 'version_2', electric_company: 'version_3', free_parking: 'version_4', go_to_jail: 'version_5', in_jail: 'version_6', luxury_tax: 'version_7', pass_go: 'version_8', railway_station: 'version_9' };

  function hash(s) { var h = 5381, i; for (i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0; return h >>> 0; }
  function sz(u, w) { return /([?&])width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u; }
  function readArts() {
    fpv = sec.querySelector('.mpr-data');
    if (!fpv) return false;
    var its = [].slice.call(fpv.querySelectorAll('i')), pass;
    for (pass = 0; pass < 2; pass++) {
      its.forEach(function (i) {
        var s = i.getAttribute('data-s'), o = i.getAttribute('data-o'), u = i.getAttribute('data-u'), c = i.getAttribute('data-c');
        if (!s || !u || (pass === 0) === !!c) return;
        arts[s] = arts[s] || {};
        if (pass === 1 && Object.keys(arts[s]).length && !c) return;
        if (pass === 1 && arts[s][o]) return;
        arts[s][o] = { u: u, c: c ? c.split(',').map(Number) : null };
      });
    }
    colourMode = !(arts.bold || arts.thin || arts.squashed);
    return Object.keys(arts).length > 0;
  }
  function rowVal(label) {
    var rows = document.querySelectorAll('.fpr-row'), i, l, v;
    for (i = 0; i < rows.length; i++) {
      l = rows[i].querySelector('.fpr-l'); v = rows[i].querySelector('.fpr-v');
      if (l && v && l.textContent.trim().toLowerCase() === label && !/is-empty/.test(v.className)) return v.textContent;
    }
    return '';
  }
  function curVariant() {
    var f = document.querySelector('form[action*="/cart/add"] [name=id]'), id = f && f.value;
    return id ? fpv.querySelector('b[data-id="' + id + '"]') : null;
  }
  function curShape() {
    var b = curVariant(), t = '';
    if (b) t = b.getAttribute('data-t') || '';
    if (!/\((landscape|portrait|square)\)/i.test(t)) t = rowVal('size') || t;
    var m = /\((landscape|portrait|square)\)/i.exec(t);
    return m ? m[1].toLowerCase() : 'square';
  }
  function keyFor(o) {
    var k = String(o || '').trim().toLowerCase().replace(/[\s-]+/g, '_'), mm;
    if (!k) return '';
    if (arts[k]) return k;
    if (AL[k] && arts[AL[k]]) return AL[k];
    if (GB[k] && /^personalised-game-board-prints/.test(handle) && arts[GB[k]]) return GB[k];
    mm = /^(?:version|style|design|card|mix_?tape_?style)?_?(\d+)$/.exec(k);
    if (mm && arts['version_' + mm[1]]) return 'version_' + mm[1];
    return '';
  }
  function curStyle() {
    var s, b, keys = Object.keys(arts), j, opts;
    if (colourMode) {
      b = curVariant();
      if (b) {
        s = keyFor(b.getAttribute('data-c'));
        if (s) return s;
        opts = (b.getAttribute('data-v') || '').split('|');
        for (j = 0; j < opts.length; j++) {
          s = keyFor(opts[j]);
          if (s) return s;
        }
      }
      return arts.flat ? 'flat' : keys[0];
    }
    var m = /bold|thin|squashed/i.exec(rowVal('text style')), rs = m ? m[0].toLowerCase() : '';
    if (rs !== lastRow) { lastRow = rs; if (rs && arts[rs]) picked = rs; }
    s = picked;
    if (!s || !arts[s]) s = arts.bold ? 'bold' : keys[0];
    return s;
  }
  function artObj(style, shape) { var a = arts[style] || {}; return a[shape] || a.any || a[Object.keys(a)[0]] || null; }

  function homog(q, w, h) {
    var x0 = q[0], y0 = q[1], x1 = q[2], y1 = q[3], x2 = q[4], y2 = q[5], x3 = q[6], y3 = q[7];
    var sx = x0 - x1 + x2 - x3, sy = y0 - y1 + y2 - y3, dx1 = x1 - x2, dx2 = x3 - x2, dy1 = y1 - y2, dy2 = y3 - y2;
    var den = dx1 * dy2 - dx2 * dy1, g = (sx * dy2 - dx2 * sy) / den, hh = (dx1 * sy - sx * dy1) / den;
    var a = x1 - x0 + g * x1, b = x3 - x0 + hh * x3, d = y1 - y0 + g * y1, e = y3 - y0 + hh * y3;
    return 'matrix3d(' + [a / w, d / w, 0, g / w, b / h, e / h, 0, hh / h, 0, 0, 1, 0, x0, y0, 0, 1].join(',') + ')';
  }
  function enqueue(el) { queue.push(el); pump(); }
  function pump() {
    var el;
    while (active < MAXC && queue.length) {
      active++; el = queue.shift();
      buildRoom(el, function () { active--; setTimeout(pump, 30); });
    }
  }
  function buildRoom(el, done) {
    var c0 = ctx, k = el.getAttribute('data-k'), m = D[k], AW = 1000, AH = 1000 / c0.ar, html = '', i, c = c0.c, tf, art, old = el.querySelector('.mpr-st'), my = ++tok;
    if (!old || !document.body.contains(el)) { if (done) done(); return; }
    el._b = my;
    html += '<img src="' + CDN + k + '-base.jpg?width=' + BW + '" alt="" decoding="async" style="width:100%;height:100%">';
    tf = 'transform:' + homog(m.q, AW, AH) + ';mix-blend-mode:multiply;opacity:' + (m.o || 1);
    if (c) {
      art = '<div class="mpr-art" style="position:absolute;left:0;top:0;transform-origin:0 0;overflow:hidden;width:' + AW + 'px;height:' + AH + 'px;' + tf + '"><img src="' + c0.url + '" alt="" decoding="async" style="position:absolute;max-width:none;width:' + (AW / c[2]) + 'px;height:' + (AH / c[3]) + 'px;left:' + (-c[0] * AW / c[2]) + 'px;top:' + (-c[1] * AH / c[3]) + 'px"></div>';
    } else {
      art = '<img src="' + c0.url + '" alt="" decoding="async" class="mpr-art" style="width:' + AW + 'px;height:' + AH + 'px;' + tf + '">';
    }
    html += art;
    for (i = 0; i < m.L.length; i++) {
      html += '<img src="' + CDN + k + '-' + m.L[i][0] + '?width=' + BW + '" alt="" decoding="async" style="width:100%;height:100%;opacity:' + m.L[i][2] + (m.L[i][1] !== 'normal' ? ';mix-blend-mode:' + m.L[i][1] : '') + '">';
    }
    var fresh = old.cloneNode(false), first = !/is-on/.test(el.className), imgs, left, fin = false, tm;
    fresh.style.opacity = first ? '0' : '1';
    fresh.innerHTML = html;
    imgs = fresh.getElementsByTagName('img'); left = imgs.length;
    function ready() {
      var cur;
      if (fin) return; fin = true; clearTimeout(tm);
      if (el._b !== my || !document.body.contains(el)) { if (done) done(); return; }
      if (c0 !== ctx) { buildRoom(el, done); return; }
      cur = el.querySelector('.mpr-st');
      if (cur && cur.parentNode === el) el.replaceChild(fresh, cur); else el.appendChild(fresh);
      if (first) el.className += ' is-on';
      fit(el);
      if (first) requestAnimationFrame(function () { requestAnimationFrame(function () { fresh.style.opacity = '1'; }); });
      if (done) done();
    }
    function mark(im) { if (im._d) return; im._d = 1; if (--left <= 0) ready(); }
    for (i = 0; i < imgs.length; i++) {
      imgs[i].onload = (function (im) { return function () { mark(im); }; }(imgs[i]));
      imgs[i].onerror = imgs[i].onload;
    }
    for (i = 0; i < imgs.length; i++) { if (imgs[i].complete && imgs[i].naturalWidth) mark(imgs[i]); }
    tm = setTimeout(ready, 7000);
  }
  function swapArt() {
    var c = ctx, im = new Image();
    function go() {
      if (c !== ctx) return;
      [].forEach.call(grid.querySelectorAll('.mpr-room.is-on'), enqueue);
    }
    im.onload = go; im.onerror = go;
    im.src = c.url;
  }
  function fit(el) {
    var m = D[el.getAttribute('data-k')], st = el.querySelector('.mpr-st'), z = el._z || { s: 1, x: 0, y: 0 };
    if (!st) return;
    var W = el.clientWidth, H = el.clientHeight || W, s = Math.max(W / m.w, H / m.h);
    var cx = (m.q[0] + m.q[2] + m.q[4] + m.q[6]) / 4, cy = (m.q[1] + m.q[3] + m.q[5] + m.q[7]) / 4;
    var ox = Math.min(0, Math.max(W - m.w * s, W / 2 - cx * s)), oy = Math.min(0, Math.max(H - m.h * s, H / 2 - cy * s));
    st.style.transform = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.s + ') translate(' + ox + 'px,' + oy + 'px) scale(' + s + ')';
  }
  function bindZoom(el) {
    var z = el._z = { s: 1, x: 0, y: 0 }, p = null, lastTap = 0;
    function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
    function mid(t) { var r = el.getBoundingClientRect(); return { x: (t[0].clientX + t[1].clientX) / 2 - r.left, y: (t[0].clientY + t[1].clientY) / 2 - r.top }; }
    function apply(s, x, y) {
      var W = el.clientWidth, H = el.clientHeight;
      z.s = Math.min(MAXZ, Math.max(1, s));
      z.x = Math.min(0, Math.max(W - W * z.s, x));
      z.y = Math.min(0, Math.max(H - H * z.s, y));
      if (z.s > 1.001) el.classList.add('is-zoom'); else el.classList.remove('is-zoom');
      fit(el);
    }
    el.addEventListener('touchstart', function (e) {
      var t = e.touches;
      if (t.length === 2) { el.classList.add('is-zoom'); p = { m: 'pinch', d: dist(t), c: mid(t), s: z.s, x: z.x, y: z.y }; }
      else if (t.length === 1 && z.s > 1) p = { m: 'pan', cx: t[0].clientX, cy: t[0].clientY, x: z.x, y: z.y };
      else p = null;
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      var t = e.touches, c, s2;
      if (!p) return;
      if (p.m === 'pinch' && t.length === 2) {
        s2 = Math.min(MAXZ, Math.max(1, p.s * dist(t) / p.d)); c = mid(t);
        apply(s2, c.x - (p.c.x - p.x) / p.s * s2, c.y - (p.c.y - p.y) / p.s * s2);
        if (e.cancelable) e.preventDefault();
      } else if (p.m === 'pan' && t.length === 1) {
        apply(z.s, p.x + t[0].clientX - p.cx, p.y + t[0].clientY - p.cy);
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });
    el.addEventListener('touchend', function (e) {
      var now = Date.now(), t = e.changedTouches[0], r, s2;
      if (e.touches.length === 0 && z.s < 1.05) apply(1, 0, 0);
      if (e.touches.length === 0 && !(p && p.m === 'pinch') && t) {
        if (now - lastTap < 300) {
          r = el.getBoundingClientRect(); s2 = z.s > 1 ? 1 : MAXZ;
          apply(s2, (t.clientX - r.left) - ((t.clientX - r.left) - z.x) / z.s * s2, (t.clientY - r.top) - ((t.clientY - r.top) - z.y) / z.s * s2);
          lastTap = 0;
        } else lastTap = now;
      }
      p = null;
    }, { passive: true });
  }
  var ro = window.ResizeObserver ? new ResizeObserver(function (es) { es.forEach(function (e) { if (e.target._z) { e.target._z.s = 1; e.target._z.x = 0; e.target._z.y = 0; e.target.classList.remove('is-zoom'); } fit(e.target); }); }) : null;
  function addRooms() {
    var end = Math.min(list.length, shown + PER), i, el;
    for (i = shown; i < end; i++) {
      el = document.createElement('div');
      el.className = 'mpr-room'; el.setAttribute('data-k', list[i]);
      el.style.aspectRatio = '1/1';
      el.setAttribute('role', 'img'); el.setAttribute('aria-label', 'Your print displayed in a room');
      el.innerHTML = '<div class="mpr-st" style="width:' + D[list[i]].w + 'px;height:' + D[list[i]].h + 'px"></div>';
      grid.appendChild(el);
      bindZoom(el);
      if (ro) ro.observe(el);
      if (io) io.observe(el); else enqueue(el);
    }
    shown = end;
    more.hidden = shown >= list.length;
  }
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); if (ctx) enqueue(e.target); } });
    }, { rootMargin: (MOB ? '1800px' : '1100px') + ' 0px' });
  }
  function drawTabs(style) {
    var ks = colourMode ? [] : STYLES.filter(function (s) { return arts[s]; });
    if (ks.length < 2) { tabs.innerHTML = ''; return; }
    tabs.innerHTML = ks.map(function (s) {
      return '<button type="button" data-s="' + s + '" class="' + (s === style ? 'on' : '') + '">' + s.charAt(0).toUpperCase() + s.slice(1) + '</button>';
    }).join('');
  }
  function noteText(style, shape) {
    var col = /^(flat|version_\d+)$/.test(style) ? '' : style.replace(/_/g, ' ');
    if (!isCustom) return col ? 'Example room views of the ' + col + ' print.' : 'Example room views of this print.';
    if (colourMode) return col ? 'Example design in ' + col + '. Your print will show your own details.' : 'Example design. Your print will show your own details.';
    return 'Example artwork in a ' + shape + ' frame. Your print will show your own location and text.';
  }
  function show(style, shape) {
    var a = artObj(style, shape);
    if (!a) { sec.hidden = true; return; }
    var url = sz(a.u, a.c ? CAW : AWD);
    function go(ar) {
      var ks = Object.keys(D).filter(function (k) { return Math.abs(ar / D[k].r - 1) <= TOL; });
      ks.sort(function (x, y) { return hash(handle + x) - hash(handle + y); });
      if (!ks.length) { sec.hidden = true; return; }
      var same = shown > 0 && !sec.hidden && list.length === ks.length && list.join('|') === ks.join('|');
      ctx = { url: url, c: a.c, ar: ar };
      drawTabs(style);
      note.textContent = noteText(style, shape);
      sec.hidden = false;
      if (same) { swapArt(); return; }
      grid.style.minHeight = grid.offsetHeight + 'px';
      queue = [];
      list = ks; shown = 0; grid.innerHTML = ''; addRooms();
      setTimeout(function () { grid.style.minHeight = ''; }, 900);
    }
    var key = url + '|' + (a.c || '');
    if (ratios[key]) return go(ratios[key]);
    var im = new Image();
    im.onload = function () {
      ratios[key] = a.c ? (a.c[2] * im.naturalWidth) / (a.c[3] * im.naturalHeight) : im.naturalWidth / im.naturalHeight;
      go(ratios[key]);
    };
    im.onerror = function () { sec.hidden = true; };
    im.src = url;
  }
  function tick() {
    var style = curStyle(), shape = curShape(), key = style + '|' + shape;
    if (key === last) { pend = ''; return; }
    if (key !== pend) { pend = key; return; }
    last = key; pend = ''; show(style, shape);
  }
  function start() {
    if (!readArts()) return;
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[data-s]');
      if (b) { picked = b.getAttribute('data-s'); tick(); tick(); }
    });
    more.addEventListener('click', addRooms);
    tick(); tick(); setInterval(tick, 350);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
}());
